import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSummernoteModule } from 'ngx-summernote';

@Component({
  selector: 'app-richtextarea',
  templateUrl: './richtextarea.component.html',
  styleUrls: ['./richtextarea.component.scss'],
  imports: [CommonModule, NgxSummernoteModule],
})
export class RichtextareaComponent implements OnInit {
  @Input() value = '';
  @Input() label: string;
  @Input() error: string;
  @Input() placeholder: string;
  @Input() size: 'small' | 'medium' | 'large' = 'medium';

  @Output() valueChange = new EventEmitter<string>();

  loaded = false;

  config: any = {
    height: '108px',
    toolbar: [
      ['style', ['bold', 'italic', 'underline']],
      ['para', ['ul', 'ol', 'paragraph']],
    ],
  };

  constructor() {}

  ngOnInit() {
    this.config = {
      ...this.config,
      placeholder: this.placeholder,
    };

    setTimeout(() => (this.loaded = true), 1);
  }

  onChange(newContent) {
    const cleanedContent = this.removeFigmaMetadata(newContent);
    this.valueChange.emit(cleanedContent);
  }

  // We've encountered cases where users copy-paste content from Figma, which includes hidden metadata that causes issues when saving the content. This removes any spans with 'data-metadata' or 'data-buffer' attributes.
  private removeFigmaMetadata(htmlContent: string): string {
    if (!htmlContent || (!htmlContent.includes('data-metadata') && !htmlContent.includes('data-buffer'))) {
      return htmlContent;
    }

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;

    const metadataSpans = tempDiv.querySelectorAll('span[data-metadata], span[data-buffer]');
    metadataSpans.forEach(span => span.remove());

    return tempDiv.innerHTML;
  }
}
